export default __webpack_public_path__ + "static/media/IconAdd.a2f68733.svg";